<template>
  <div>
    <el-input-number v-bind="$props" v-model="currentValue" @change="changeVal" :step="1" :max="6" :min="0"></el-input-number>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value || 0;
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    changeVal(val, lr) {
      this.$emit('change', val, lr)
    }
  }
}
</script>

<style>
</style>
